export const Tag = ({ children }) => {
  return (
    <span className="inline-block text-xm bg-white/80 dark:bg-black font-semibold mb-1 rounded p-1 mr-1">
      {children}
    </span>
  );
};
